// extracted by mini-css-extract-plugin
export default {"userTypeCard":"user-type-modal_userTypeCard__jb3gh","cardTitle":"user-type-modal_cardTitle__DfXo3"};